import { render, staticRenderFns } from "./import-questionUs.vue?vue&type=template&id=4b03fdb7&scoped=true&"
import script from "./import-questionUs.vue?vue&type=script&lang=ts&"
export * from "./import-questionUs.vue?vue&type=script&lang=ts&"
import style0 from "./import-questionUs.vue?vue&type=style&index=0&id=4b03fdb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b03fdb7",
  null
  
)

export default component.exports